import React, {ReactElement} from "react";
import {Grid} from "@components/grid/index";
import {BoxesResponse} from "@mwServices/Boxes";
import GridPagination from "@components/grid/GridPagination";

interface BoxesGridProps {
    isLoading: boolean;
    className?: string;
    data?: BoxesResponse;
    paginationType?: number;
    onPaginationChange?: (page: number) => void;
    onPaginationSizeChange?: (current: number, perPage: number) => void;
    BoxRender: (props: BoxRenderProps) => ReactElement;
    noDataMessage?: string;
    getItemProps: (item: any) => any;
}

export interface BoxRenderProps {
    item: any;
    filters?: any;
    onClick?: (item) => void;
    setEditBox?: (box) => void;
    showEditMultiple?: boolean;
    isSelected?: boolean;
    toggleSelected?: (id: number) => void;
    onGainLossInfoClick?: () => void;
    showDesktopView?: boolean;
}


const BoxesGrid = ({
   isLoading,
   className,
   data,
   paginationType,
   onPaginationChange,
   onPaginationSizeChange,
   BoxRender,
   noDataMessage,
   getItemProps,
}: BoxesGridProps) => {
  return (
      <Grid
          isListGrid={true}
          className={className ? className : ''}
          loading={isLoading}
          dataSource={data ? data.boxes : []}
          noDataMessage={noDataMessage}
          IssueRender={BoxRender}
          getItemProps={getItemProps}
          pagination={<GridPagination
              data={data}
              paginationType={paginationType}
              onPaginationChange={onPaginationChange}
              onPaginationSizeChange={onPaginationSizeChange}
          />}
      />
  );
};

export default BoxesGrid;
